"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function SummaryTable(_ref) {
  var items = _ref.items;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['table']
    }, items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['table__row'],
        key: index
      }, /*#__PURE__*/_react["default"].createElement("span", null, "\u0421\u0442\u0440\u043E\u043A\u0430 ", item['rowNumber'], ", ", item['message']));
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = SummaryTable;
exports["default"] = _default;